import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import isPropValid from '@emotion/is-prop-valid';

import {
  gutterXs,
  gutterFlexible,
  darkModeBackground,
  bannerFontFamily,
  warm,
} from '@style/variables.js';

interface CalloutCardProps {
  theme?: any;
  alignRight: boolean;
  calloutCard: boolean;
}

export const CalloutCard = styled('div', { shouldForwardProp: isPropValid })(
  ({ theme, alignRight, calloutCard }: CalloutCardProps) => ({
    minHeight: '140vw',
    textAlign: 'left',
    backgroundColor: warm[200],
    position: 'relative',
    zIndex: 1,
    marginBottom: gutterXs,
    marginRight: alignRight ? 0 : 'auto',
    marginLeft: alignRight ? 'auto' : 0,
    [theme.breakpoints.up('sm')]: {
      minHeight: '50vw',
      marginBottom: `${gutterFlexible}vw`,
    },
    [theme.breakpoints.up('md')]: {
      width: '80%',
      maxWidth: '1280px',
      minHeight: '40vw',
      marginBottom: `${Number(gutterFlexible) * -2}vw`,
    },
    '@media (min-width: 1600px)': {
      height: '720px',
      minHeight: '720px',
    },
    '&:last-child': {
      marginBottom: 0,
    },

    '& > *, & > * > *': {
      minHeight: calloutCard ? 'inherit' : '',
    },
  }),
);

export const StyledGrid = styled(Grid)({
  position: 'relative',
});

export const Image = styled(LazyLoadImage)({
  height: '100%',
  '& img': {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
});

export const Content = styled('div')(({ theme }) => ({
  padding: gutterXs,
  [theme.breakpoints.up('md')]: {
    padding: `${Number(gutterFlexible) * 2}vw`,
  },
}));

export const AuthorContent = styled(ToutContent)(({ theme }) => ({
  padding: gutterXs,
  [theme.breakpoints.up('md')]: {
    padding: `${Number(gutterFlexible) * 2}vw`,
    maxWidth: '75%',
  },
}));

export const AuthorImage = styled(LazyLoadImage)(({ theme }) => ({
  '& img': {
    borderRadius: 40,
    marginRight: '8px',
    width: '30px',
    [theme.breakpoints.up('sm')]: {
      width: '37px',
    },
  },
}));

export const BackgroundImage = styled(LazyLoadImage)(({ theme }) => ({
  '& img': {
    position: 'absolute',
    bottom: 0,
    width: '90% !important',
    left: '5%',
    zIndex: -1,
    [theme.breakpoints.up('sm')]: {
      width: '40%',
    },
  },
}));

export const Summary = styled(Box)(({ theme }) => ({
  color: '#b4ada5',
  backgroundColor: darkModeBackground,
  marginLeft: `calc(-1 * ${gutterXs})`,
  marginRight: `calc(-1 * ${gutterXs})`,
  padding: `0 ${gutterXs}`,
  [theme.breakpoints.up('md')]: {
    padding: `0 ${Number(gutterFlexible) * 2}vw`,
    margin: `0 ${Number(gutterFlexible) * -2}vw`,
  },
}));

export const EffortLabel = styled(Box)({
  '& span': {
    textTransform: 'uppercase',
    fontFamily: bannerFontFamily,
    fontWeight: 'bold',
    fontSize: '1rem',
    lineHeight: '0.9rem',
    letterSpacing: '1.35px',
  },
});

export const DividerVertical = styled('div')(({ theme }) => ({
  width: '1px',
  height: '2.5rem',
  backgroundColor: warm[400],
  margin: '0 0.2rem',
  [theme.breakpoints.up('lg')]: {
    margin: '0 24px',
  },
}));

export const Label = styled('span')({
  textTransform: 'uppercase',
  fontFamily: bannerFontFamily,
  fontSize: '1.25rem',
  lineHeight: '1.1rem',
  letterSpacing: '0.83px',
  width: '1.5rem',
});

export const NumberContainer = styled('span')({
  fontSize: '3rem',
  fontWeight: 'bold',
  fontFamily: bannerFontFamily,
  paddingRight: '0.25rem',
});
